import { render, staticRenderFns } from "./TodayApp.vue?vue&type=template&id=48af84c9&"
import script from "./TodayApp.vue?vue&type=script&lang=js&"
export * from "./TodayApp.vue?vue&type=script&lang=js&"
import style0 from "./TodayApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TodayApp.vue"
export default component.exports